export async function platformFetch(...args) {
  const response = await fetch(...args);
  if (response.status === 403) {
    const body = await response
      .clone()
      .json()
      .catch(() => ({}));
    if (body.code === "EMAIL_VERIFICATION_REQUIRED")
      window.dispatchEvent(new CustomEvent("pso:email-verification-required"));
    if (body.code === "CONTRACT_ACCEPTANCE_REQUIRED")
      window.dispatchEvent(new CustomEvent("pso:contract-required"));
  }
  return response;
}
